module.exports = __webpack_public_path__ + "static/img/12.9608a18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/zh/12.png
// module id = IqQC
// module chunks = 0